/**
 * The script every page runs. Each import looks after one thing the whole store shares; a section
 * that needs more loads its own module from its own markup.
 */
import "@theme/component-cart-drawer";
import "@theme/component-anchor-scroll";
import "@theme/component-overscroll";
